<template>
  <div class="input-group max-w-300px">
    <label v-if="title" :id="id">{{ title }}</label>
      <span :class="['base-date-picker flex rounded',
    { 'border  border-solid border-muted': !invalid },
    { 'border border-solid border-danger': invalid }]">
      <v-date-picker
        :locale="{ id: 'ru' }"
        :value="value"
        @input="$emit('input', $event)"
        class="flex-grow"
        :mode="mode"
        :popover="popover"
        :columns="columns"
        :rows="rows"
      >
        <input
          ref="input"
          slot-scope='{ inputValue, updateValue }'
          type='text'
          :value='inputValue'
          @change='updateValue($event.target.value, { hidePopover: false, formatInput: true })'
          :placeholder="placeholder"
          class="
            input
            w-full
            px-4
            py-4
            text-sm
            border-0
            border-none
            border-transparent
            bg-transparent
            outline-none
          "
        >
      </v-date-picker>
    </span>
  </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';

export default {
  components: {
    'v-date-picker': DatePicker,
  },
  name: 'BaseInput',
  data() {
    return {
      date: new Date(),
    };
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    invalid: {
      type: Boolean,
      default: false,
    },
    popover: {
      type: Object,
    },
    rows: {
      type: Number,
      default: 1,
    },
    columns: {
      type: Number,
      default: 1,
    },
    mode: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    value: {
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    key() {
      return this.id ? 'id' : null;
    },
  },
};
</script>
<style lang="scss" scoped>
  .input::placeholder {
    color: inherit;
  }
</style>
